import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import MasterTable from "../MasterTable/MasterTable";
import KitTable from "../KitTable/KitTable";
import BundleTable from "../BundleTable/BundleTable";
import SimpleProductsTable from '../SimpleProductsTable/SimpleTable';
import VariantTable from '../VariantProductsTable/VariantTable';
import Socket from "../../config/socket_services";
import { useAuth } from '../UserAuth/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import commonApiService from '../../config/common_api';

const Navigation = ({ globalList, setGlobalList }) => {
  const { userData } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Maps for tab routing
  const pathToKeyMap = {
    '/app/home': 'home',
    '/app/kits': 'kits',
    '/app/bundles': 'bundles',
    '/app/simple_products': 'simple_products',
    '/app/variants': 'variants',
  };



  const keyToPathMap = Object.fromEntries(
    Object.entries(pathToKeyMap).map(([path, key]) => [key, path])
  );

  // Get current active tab from URL or default to all_products
  const currentPath = location.pathname;
  const activeTab = pathToKeyMap[currentPath] || 'home';

  // Navigate on tab change
   const onChange = (key) => {
    navigate(keyToPathMap[key]);
  };


  // Fetch common data once on mount
  useEffect(() => {
    const fetchCommonData = async () => {
      try {
        await Promise.all([
          commonApiService.get_stores(),
          commonApiService.GetFrontendTabs(),
          commonApiService.get_sap_skus(),
          commonApiService.get_bc_skus(),
          commonApiService.get_all_category_tree(),
        ]);
      } catch (err) {
        console.error('Error fetching common data', err);
      }
    };
    fetchCommonData();
  }, []);

  // Custom tab bar with socket button
  const customTabBar = (props, DefaultTabBar) => (
    <div className="TabListTopBox">
      <DefaultTabBar {...props} />
      {userData?.data?.access === "ALL" && (
        <div className="SocketBtn">
          <Socket globalList={globalList} setGlobalList={setGlobalList} />
        </div>
      )}
    </div>
  );

  const items = [
    {
      key: 'home',
      label: 'All Products',
      children: <MasterTable globalList={globalList} setGlobalList={setGlobalList} />,
    },
    {
      key: 'kits',
      label: 'Kits',
      children: <KitTable globalList={globalList} setGlobalList={setGlobalList} />,
    },
    {
      key: 'bundles',
      label: 'Bundles',
      children: <BundleTable globalList={globalList} setGlobalList={setGlobalList} />,
    },
    {
      key: 'simple_products',
      label: 'Simple Products',
      children: <SimpleProductsTable globalList={globalList} setGlobalList={setGlobalList} />,
    },
    {
      key: 'variants',
      label: 'Products w/ Variants',
      children: <VariantTable globalList={globalList} setGlobalList={setGlobalList} />,
    },
  ];

  return (
    <div className="TopTablesTabsBox TabNavigation">
      <Tabs
        activeKey={activeTab}
        onChange={onChange}
        renderTabBar={customTabBar}
        className="TopTablesTabs"
        items={items}
      />
    </div>
  );
};

export default Navigation;
